//@import dependencies
import React, {useState} from 'react'
//@end

//@import components
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import NewsModule from 'app_components/modules/campus/news'
import PortfolioModule from 'app_components/modules/campus/academic/portfolio/index';
import ProgramsModule from 'app_components/modules/campus/academic/programs/index';
import StatsSchedulingModule from 'app_components/modules/campus/academic/StatsSchedulingModule/StatsSchedulingModule';
import MyClientsModule from 'app_components/modules/campus/academic/myClients/index';
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../executiveHomeModule.scss'

// @ADD Component types
interface IExecutiveHomeModuleLayoutProps {}

const ExecutiveHomeModuleLayout: React.FC<IExecutiveHomeModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  const [menuSelected, setMenuSelected] = useState('1');
  const menus = [
    { name: t('modules.account_executive_home.portfolio'), value: '1', status: 'enabled' },
    { name: t('modules.account_executive_home.programs'), value: '2', status: 'enabled' },
    { name: t('modules.account_executive_home.my_clients'), value: '3', status: 'enabled' },
    { name: t('modules.account_executive_home.stats'), value: '4', status: 'enabled' },
  ];

  return(
    <div className='executive_home_module-layout'>
      <section className="executive-dashboard-section-news">
        <NewsModule category='account_executive' />
      </section>
      <section className="executive-dashboard-main">
        <div className="row">
          <div className="col-12">
            <div className="executive-sections">
              <ButtonGroup toggle>
                {menus.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    type="radio"
                    variant="secondary"
                    name="radio"
                    value={radio.value}
                    checked={menuSelected === radio.value}
                    onChange={(e) => setMenuSelected(e.currentTarget.value)}
                    disabled={radio.status === 'disabled'}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </div>

            {menuSelected === '1' && (<PortfolioModule />)}
            {menuSelected === '2' && (<ProgramsModule />)}
            {menuSelected === '3' && (<MyClientsModule />)}
            {menuSelected === '4' && (<StatsSchedulingModule />)}
          </div>
        </div>
      </section>
      <section></section>
    </div>
  )
}

export default ExecutiveHomeModuleLayout
